/** Hop di link sotto la radice: radice a profondita' 0, ultimo figlio ammesso a 3. */
export const MAX_INGREDIENT_COMPOSITION_DEPTH = 3;

/** Nodi materializzati per radice, diamanti ripetuti inclusi: oltre, il ramo diventa TOO_LARGE. */
export const MAX_INGREDIENT_COMPOSITION_PATHS = 200;

/**
 * Livelli di sotto-voci inline sotto la voce di primo livello: la voce (livello
 * 0) puo' avere figlie (1) e nipoti (2), oltre si sposta in archivio. Le righe
 * inline non consumano hop di link (`MAX_INGREDIENT_COMPOSITION_DEPTH`) ne'
 * nodi materializzati (`MAX_INGREDIENT_COMPOSITION_PATHS`).
 */
export const MAX_INLINE_COMPONENT_DEPTH = 2;
